<form class="date-range">
  <div class="date-container">
    <div class="label">Du</div>
    <div class="date-wrapper">
      <div class="dp-hidden position-absolute">
        <div class="input-group">
          <input name="datepicker"
                 class="form-control h-100"
                 ngbDatepicker
                 #datepicker="ngbDatepicker"
                 [autoClose]="'outside'"
                 (dateSelect)="onDateSelection($event)"
                 [displayMonths]="1"
                 [dayTemplate]="t"
                 outsideDays="hidden"
                 [startDate]="fromDate!"
                 tabindex="-1">
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day"
                  [class.focused]="focused"
                  [class.range]="isRange(date)"
                  [class.rangeLocked]="isRangeLocked(date)"
                  [class.faded]="isHovered(date)"
                  (mouseenter)="hoveredDate = date"
                  (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
        </div>
      </div>
      <div class="q-date">
        <input #dpFromDate
               class="dp-range"
               placeholder="JJ/MM/AAAA"
               name="dpFromDate"
               [value]="fromDate|ngbDate"
               (input)="fromDate = validateInput(fromDate, dpFromDate.value)" (click)="target='FROM';datepicker.toggle()" readonly>

        <i *ngIf="fromDate" class="fas fa-times q-c-danger" (click)="target='FROM';deleteDate($event)"></i>
      </div>
    </div>
  </div>

  <div class="date-container">
    <div class="label">Au</div>
    <div class="q-date">
      <input #dpToDate
             class="dp-range"
             placeholder="JJ/MM/AAAA"
             name="dpToDate"
             [value]="toDate|ngbDate"
             (input)="toDate = validateInput(toDate, dpToDate.value)" (click)="target='TO';datepicker.toggle()" readonly>
      <i *ngIf="toDate" class="fas fa-times q-c-danger" (click)="target='TO';deleteDate($event)"></i>
    </div>
  </div>
</form>

